import { render, staticRenderFns } from "./ArticleCategoryOverview.vue?vue&type=template&id=6fa9b0d7&scoped=true&"
import script from "./ArticleCategoryOverview.vue?vue&type=script&lang=js&"
export * from "./ArticleCategoryOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa9b0d7",
  null
  
)

export default component.exports